/* global UIkit */
import Mojito from '../../../bower_components/mojito/lib/main';

export default class FilterController extends Mojito.Controller {

    constructor(filter, ...args) {
        super(args);


        this.set('grid', UIkit.grid(filter.content, {
            gutter: 20
        }));

        if(filter.filter !== undefined) {
            try {
                let grid = this.get('grid');
                    grid.filter(filter.filter);
            } catch(e) {
                console.log(e.message);
            }
        }
    }

    optionObserver() {
        return Mojito.observer('option', function () {
            let grid = this.get('grid');

            if (grid !== null) {
                if (this.get('option') === 'filterAll') {
                    grid.filter();
                } else {
                    grid.filter(this.get('option'));
                }
            }
        });
    }

    setOption(value) {
        if (typeof (value) === 'string') {
            this.set('option', value);
        } else {
            this.set('option', value.filter);
        }
    }


}
